module.exports = __webpack_public_path__ + "static/media/inside_porte.683f56ec.png";